module.exports = __webpack_public_path__ + "img/yn.8b0bfc6c.png";